import { useMemo } from 'react';
import { isNullItem } from "../functions/isNullItem.js";
export function useFavoriteItems(favorites, isFiltered, items) {
  return useMemo(() => isFiltered ? {
    // Do not set favorites if items are filtered
    favoriteItems: [],
    otherItems: items
  } : {
    favoriteItems: items.filter(i => !isNullItem(i) && favorites.includes(i.key)),
    otherItems: items.filter(i => isNullItem(i) || !favorites.includes(i.key))
  }, [items, favorites, isFiltered]);
}